import { Routes } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { LoginMasterComponent } from './pages/login-master/login-master.component';
import { ResetPageComponent } from './pages/reset-page/reset-page.component';
import { SignUpPageComponent } from './pages/sign-up-page/sign-up-page.component';
import { LoginArt } from './models/login-art.enum';
var ɵ0 = {
    loginArt: LoginArt.login
}, ɵ1 = {
    loginArt: LoginArt.login
}, ɵ2 = {
    loginArt: LoginArt.signUp
};
var routes = [
    {
        path: 'login',
        component: LoginMasterComponent,
        children: [
            {
                path: '',
                component: LoginPageComponent,
                data: ɵ0
            },
            {
                path: 'reset',
                component: ResetPageComponent,
                data: ɵ1
            },
            {
                path: 'create',
                component: SignUpPageComponent,
                data: ɵ2
            }
        ]
    }
];
var AuthRoutingModule = /** @class */ (function () {
    function AuthRoutingModule() {
    }
    return AuthRoutingModule;
}());
export { AuthRoutingModule };
export { ɵ0, ɵ1, ɵ2 };
